import React from "react";
import { STATION_HALF_SIZE } from "../utils/constants";

const RING_COUNT = 3;
const MAX_RADIUS = 36;
const ANIMATION_DURATION = 3.6;

const SignalPulse = ({ color = "#1890ff" }) => {
  const size = MAX_RADIUS * 2;

  return (
    <svg
      style={{
        position: "absolute",
        top: STATION_HALF_SIZE - MAX_RADIUS,
        left: STATION_HALF_SIZE - MAX_RADIUS,
        width: size,
        height: size,
        pointerEvents: "none",
        overflow: "visible",
      }}
      aria-hidden="true"
    >
      {Array.from({ length: RING_COUNT }, (_, i) => (
        <circle
          key={i}
          cx={MAX_RADIUS}
          cy={MAX_RADIUS}
          r={STATION_HALF_SIZE}
          fill="none"
          stroke={color}
          strokeWidth={1.5}
          opacity={0}
        >
          <animate
            attributeName="r"
            from={STATION_HALF_SIZE}
            to={MAX_RADIUS}
            dur={`${ANIMATION_DURATION}s`}
            begin={`${(i * ANIMATION_DURATION) / RING_COUNT}s`}
            repeatCount="indefinite"
          />
          <animate
            attributeName="opacity"
            from="0.6"
            to="0"
            dur={`${ANIMATION_DURATION}s`}
            begin={`${(i * ANIMATION_DURATION) / RING_COUNT}s`}
            repeatCount="indefinite"
          />
        </circle>
      ))}
    </svg>
  );
};

export default SignalPulse;
